import {
  Component,
  inject,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import {
  NgbDropdown,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { Subscription, of, timer } from 'rxjs';
import { retry, catchError, take, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-lang-selector',
  templateUrl: './lang-selector.component.html',
  styleUrls: ['./lang-selector.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    AngularSvgIconModule,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
  ],
})
export class LangSelectorComponent implements OnInit, OnDestroy {
  private translate = inject(TranslateService);
  private route = inject(ActivatedRoute);

  @Input() style: 'text' | 'dropdown' = 'text';
  @Input() enableHover = true;

  currentLang = 'th';
  private languageSubscription?: Subscription;

  ngOnInit(): void {
    this.detectLanguage();
  }

  ngOnDestroy(): void {
    this.languageSubscription?.unsubscribe();
  }

  changeLanguage(lang: string): void {
    this.currentLang = lang;
    if (lang === 'en') {
      this.translate.use('en');
      localStorage.setItem('lang', 'en');
    }
    if (lang === 'th') {
      this.translate.use('th');
      localStorage.setItem('lang', 'th');
    }
  }

  detectLanguage(): void {
    const routeLang = this.route.snapshot.queryParams['lang'];
    const storedLang = localStorage.getItem('lang');
    this.currentLang =
      routeLang ?? storedLang ?? this.translate.currentLang;

    this.languageSubscription?.unsubscribe();

    this.languageSubscription = timer(0, 100)
      .pipe(
        take(5),
        switchMap(() =>
          this.translate.use(this.currentLang).pipe(
            retry({ count: 3, delay: () => timer(100) }),
            catchError(() => of(false)),
          ),
        ),
      )
      .subscribe();
  }
}
